import type { ReactNode } from 'react'
import { useAuth } from 'react-oidc-context'
import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { DialogProvider } from './components/Dialogs'
import { Dashboard } from './pages/Dashboard'
import { Login } from './pages/Login'
import { Customers } from './pages/Customers'
import { CustomerEdit } from './pages/CustomerEdit'
import { DeliveryAreas } from './pages/DeliveryAreas'
import { DeliveryAreaDetail } from './pages/DeliveryAreaDetail'
import { Products } from './pages/Products'
import { ProductEdit } from './pages/ProductEdit'
import { OrderEdit } from './pages/OrderEdit'
import { WebOrders } from './pages/WebOrders'
import { SyncFailures } from './pages/SyncFailures'
import { RingList } from './pages/RingList'
import { DeliveryList } from './pages/DeliveryList'
import { Invoices } from './pages/Invoices'
import { InvoiceDetail } from './pages/InvoiceDetail'
import { Settings } from './pages/Settings'
import { CustomerSelfService } from './pages/CustomerSelfService'

export default function App() {
  const auth = useAuth()

  // Public customer self-service (AccessKey-gated) — no operator OIDC login.
  if (window.location.pathname.startsWith('/min-sida')) {
    return <CustomerSelfService />
  }

  if (auth.isLoading) {
    return <CenteredMessage title="Laddar…" />
  }

  if (auth.error) {
    return (
      <CenteredMessage title="Inloggningsfel">
        <p className="muted">{auth.error.message}</p>
        <button onClick={() => void auth.signinRedirect()}>Försök igen</button>
      </CenteredMessage>
    )
  }

  if (!auth.isAuthenticated) {
    return <Login />
  }

  return (
    <DialogProvider>
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/new" element={<CustomerEdit />} />
        <Route path="/customers/:id" element={<CustomerEdit />} />
        <Route path="/delivery-areas" element={<DeliveryAreas />} />
        <Route path="/delivery-areas/:id" element={<DeliveryAreaDetail />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/new" element={<ProductEdit />} />
        <Route path="/products/:id" element={<ProductEdit />} />
        <Route path="/orders/new" element={<OrderEdit />} />
        <Route path="/orders/:id" element={<OrderEdit />} />
        <Route path="/web-orders" element={<WebOrders />} />
        <Route path="/sync-failures" element={<SyncFailures />} />
        <Route path="/ring-list" element={<RingList />} />
        <Route path="/delivery-list" element={<DeliveryList />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/:id" element={<InvoiceDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/auth/callback" element={<Dashboard />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </Layout>
    </DialogProvider>
  )
}

function CenteredMessage({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="center-screen">
      <div className="card">
        <h1>{title}</h1>
        {children}
      </div>
    </div>
  )
}
